import type { BubblePlan, EducationalPlan } from '@innovamat/glow-api-client';
import type { Classroom } from '@innovamat/radiance-utils';
import { stages } from '@innovamat/radiance-utils';

import { useBubblePlans } from '../../../hooks/use-bubble-plans';
import { useEducationalPlans } from '../../../hooks/use-education-plans';

type Props = {
  classroom: Classroom;
  enabled?: boolean;
};

type PracticeLevelOptions = (EducationalPlan | BubblePlan)[];

function useStudentsPracticeLevel({ classroom, enabled = true }: Props) {
  const isSecundaria = !!stages.isSecundaria(classroom?.courseOrder);

  const { educationOptions, getEducationalPlanByCourse } = useEducationalPlans({
    filterOrderCourse: classroom?.courseOrder,
    enabled: enabled && isSecundaria,
  });

  const { bubblePlanOptions, getBubblePlanByCourse } = useBubblePlans({
    courseOrder: classroom?.courseOrder,
    enabled: enabled && !isSecundaria,
  });

  const getPracticeLevelByCourse = (courseId: string) => {
    return {
      educationalPlan: isSecundaria
        ? getEducationalPlanByCourse(courseId)
        : null,
      bubblePlan: !isSecundaria ? getBubblePlanByCourse(courseId) : null,
    };
  };

  const practiceLevelOptions = [...educationOptions, ...bubblePlanOptions];

  return {
    practiceLevelOptions,
    getPracticeLevelByCourse,
  };
}

export { useStudentsPracticeLevel };
export type { PracticeLevelOptions };
